import ReactDOM from 'react-dom'

import { useWaitForDOMRef } from './useWaitForDOMRef'
import { MutableRefObject, ReactNode } from 'react'

interface Props {
  container: MutableRefObject<any> | Element
  onRendered?: (ref: MutableRefObject<any>) => void
  children: ReactNode
}

export const Portal = ({ container, children, onRendered }: Props) => {
  const resolvedContainer = useWaitForDOMRef(container, onRendered)

  return resolvedContainer ? ReactDOM.createPortal(children, resolvedContainer) : null
}
